module.exports = __webpack_public_path__ + "static/illu-survey-6542f79081772c0a01a0b1c55e53bd35.jpg";